import { Outlet } from "react-router-dom";

const AdminInterface = () => {
  return <Outlet />;
};

export default AdminInterface;
